import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $ = _ref.$,
      $f7ready = _ref.$f7ready,
      $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $update = _ref.$update,
      $on = _ref.$on;

  /*
   * IMPORTANTE!
   * In questa pagina, $update() non ha effetto, quindi bisonga usare i metodi 
   *  - $('#avatar').css('background-image', 'url( ... )') per aggiornare l'immagine di profilo
   *  - attributo data-translate="language_key"  per le traduzioni dei test
   *  - attributo data-if="condition" per visualizzare | nascondere un elemento
   *  
   * Questi metodi vengono chimati nell'evento 'panelOpen' -> updatePanel() 
   */
  var username = '',
      password = Date.now(),
      repeatpwd = '',
      loginErrorMessage = '',
      title = 'Login',
      signIn = true,
      avatar = 'static/avatar.svg',
      user = {
    data: {
      childrens: []
    }
  },
      f7 = $f7,
      languages = {
    it: 'Italiano',
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
    es: 'Español'
  };
  user.data = user.data || {};
  user.data.childrens = user.data.childrens || [];
  /**
   * Framework ready
   */

  $f7ready(function () {
    $f7.on('panelOpen', updatePanel);
  });

  var cancelQrcodeScan = function cancelQrcodeScan() {
    return $f7.pwaQrcodeScanner('stop');
  };
  /**
   * Aggiorna i dati del pannello
   * @returns {undefined}
   */


  var updatePanel = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data, children;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return myApp.user();

            case 2:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.t0 = {};

            case 5:
              user = _context.t0;
              data = user.data || {};
              user.data.childrens = user.data.childrens || [];

              if (!(data.avatar && !myApp.children)) {
                _context.next = 17;
                break;
              }

              _context.next = 11;
              return myStorage.get(data.avatar);

            case 11:
              _context.t1 = _context.sent;

              if (_context.t1) {
                _context.next = 14;
                break;
              }

              _context.t1 = data.avatar;

            case 14:
              avatar = _context.t1;
              _context.next = 29;
              break;

            case 17:
              if (!myApp.children) {
                _context.next = 29;
                break;
              }

              children = user.data.childrens.find(function (e) {
                return e.id == myApp.children;
              });
              children.data = children.data || {};
              _context.next = 22;
              return myStorage.get(children.data.avatar);

            case 22:
              _context.t3 = _context.sent;

              if (_context.t3) {
                _context.next = 25;
                break;
              }

              _context.t3 = children.data.avatar;

            case 25:
              _context.t2 = _context.t3;

              if (_context.t2) {
                _context.next = 28;
                break;
              }

              _context.t2 = 'static/pet.svg';

            case 28:
              avatar = _context.t2;

            case 29:
              $('#avatar').css({
                backgroundImage: "url('" + avatar + "')"
              });
              $('[data-if]').each(function (e) {
                eval($(e).data('if')) ? $(e).removeClass('hidden') : $(e).addClass('hidden');
              });
              $('[data-translate]').each(function (e) {
                $(e).html(lng[$(e).data('translate')]);
              });

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updatePanel() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Mostra instruzioni d'uso nella lingua dell'utente (se c'è)
   * 
   * @returns {undefined}
   */


  var getInfo = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var file_exists, l, file, html, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file_exists = ['en', 'it', 'fr', 'es', 'de'];
              l = file_exists.find(function (item) {
                return item == lng.key;
              }) || file_exists[0];
              file = 'static/html/instructions' + '_' + l + '.html';

              if (!$f7.device.cordova) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return myApp.server.readFile(file);

            case 6:
              html = _context2.sent;
              _context2.next = 15;
              break;

            case 9:
              _context2.next = 11;
              return fetch(file);

            case 11:
              res = _context2.sent;
              _context2.next = 14;
              return res.text();

            case 14:
              html = _context2.sent;

            case 15:
              $('.popup-info').find('.content').html(html);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getInfo() {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Apre popup select user
   * 
   * @returns {undefined}
   */


  var selectUser = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var tmpl, parent;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // imposta selectUserActive su window
              window.selectUserActive = window.selectUserActive || selectUserActive; // imposta primo item -> utente

              tmpl = "<li>\n                  <a href=\"#\" onclick=\"selectUserActive(this)\" data-id='primary' class=\"item-link item-content\">\n                    <div class=\"item-media\"><img class=\"avatar-list\" src=\"".concat(user.data.avatar || '/static/avatar.svg', "\"/></div>\n                    <div class=\"item-inner\">\n                      <div class=\"item-title\">").concat(user.data.name, " ").concat(user.data.lastname, "</div>\n                      <div class=\"item-after\">").concat(!myApp.children ? "<i class=\"f7-icons text-color-secondary\">checkmark_alt</i>" : '', "</div>\n                    </div>\n                  </a>\n                </li>");
              $('#popup-select-user-ul').html(tmpl); // imposta i diversi pet

              _context3.next = 5;
              return myApp.user();

            case 5:
              parent = _context3.sent;
              parent.data.childrens.forEach(function (item) {
                item.data = item.data || _objectSpread({}, item);
                var tmpl = "<li>\n                  <a href=\"#\" onclick=\"selectUserActive(this)\" data-id='".concat(item.id, "' class=\"item-link item-content\">\n                    <div class=\"item-media\"><img class=\"avatar-list\" src=\"").concat(item.data.avatar || '/static/pet.svg', "\"/></div>\n                    <div class=\"item-inner\">\n                      <div class=\"item-title\">").concat(item.name, " ").concat(item.lastname, "</div>\n                      <div class=\"item-after\">").concat(myApp.children == item.id ? "<i class=\"f7-icons text-color-secondary\">checkmark_alt</i>" : '', "</div>\n                    </div>\n                  </a>\n                </li>");
                $('#popup-select-user-ul').append(tmpl);
              });
              $f7.popup.open('.popup-select-user');

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function selectUser() {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Imposta utente attivo 
   * 'primary' -> Utente master
   * <number> id utente children
   * 
   * @param {type} ev
   * @returns {undefined}
   */


  var selectUserActive = function selectUserActive(ev) {
    console.log(ev);
    var el = $(ev.target || ev);

    for (var i = 0; i < 5; i++) {
      var id = el.data('id');
      console.log('Selected id: ' + id);

      if (id) {
        id === 'primary' ? delete myApp.children : myApp.children = id;
        $update();
        $f7.popup.close();
        $f7.views.main.router.refreshPage();
        break;
      } else {
        el = $(el[0].parentElement);
      }
    }
  };
  /**
   * Aggiunge utente children
   * 
   * @returns {undefined}
   */


  var addUser = function addUser() {
    if (user.data.childrens.length == 5) {
      $f7.dialog.alert('Si possono aggiungere fino a 5 pet.');
    } else {
      $f7.views.main.router.navigate('/children/_new/?pin=yes');
    }
  };
  /**
   * Chiude pannello
   */


  var panelClose = function panelClose() {
    return $f7.panel.close();
  };
  /**
   * Link a Green Pass
   * 
   * @returns {undefined}
   */


  var goToGP = function goToGP() {
    var msg = lng.get_green_pass_message_html;
    $f7.dialog.alert(msg, function () {
      return myApp.iab('https://www.dgc.gov.it/spa/public/home', '_system');
    });
  };
  /**
   * Elimina i dati salvati e reindirizza alla pagina di login 
   * 
   * @returns {undefined}
   */


  var logOut = function logOut() {
    $f7.dialog.confirm(lng.exit_question_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var uuid;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return myStorage.get('uuid');

            case 2:
              uuid = _context4.sent;
              _context4.next = 5;
              return myStorage.set('user', '');

            case 5:
              _context4.next = 7;
              return myStorage.clear();

            case 7:
              if (uuid) myApp.server.post('auth/logout', {
                uuid: uuid
              });
              if ($f7.device.cordova || true) $f7.views.main.router.navigate('/home/', {
                clearPreviousHistory: true
              });else window.location.href = 'https://webapp.doctorpass.it';

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
  };
  /**
   * Imposta codice univoco di attivazione
   * 
   * @returns {undefined}
   */


  var activationCode = function activationCode() {
    var code = $('#activationCode').val().trim();

    if (code.length < 14) {
      $f7.dialog.alert(lng.activation_code_error_message, function () {
        return $('#activationCode').focus();
      });
      return;
    }

    var success = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                $f7.preloader.show();
                _context5.prev = 1;
                _context5.next = 4;
                return myApp.server.putJSON('user/me/activation_code?children=', {
                  code: code
                });

              case 4:
                data = _context5.sent;

                if (myApp.children) {
                  _context5.next = 10;
                  break;
                }

                user.activation_code = code;
                _context5.next = 9;
                return myApp.user(user);

              case 9:
                myApp.reloadPage = true;

              case 10:
                $f7.popup.close();
                $f7.dialog.alert(lng.activation_code_success_message);
                _context5.next = 17;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](1);
                $f7.dialog.alert(lng.error_message + '<br/>' + _context5.t0.message);

              case 17:
                _context5.prev = 17;
                $f7.preloader.hide();
                return _context5.finish(17);

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 14, 17, 20]]);
      }));

      return function success() {
        return _ref6.apply(this, arguments);
      };
    }();

    if (user.activation_code) {
      $f7.dialog.confirm(lng.activation_code_update_message.replace('%company_name%', user.company_1), success, false);
    } else {
      success();
    }
  };
  /*
   * Associa card tramite qrscan
   * @returns {undefined}
   */


  var linkCard = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!$f7.device.cordova) {
                _context6.next = 6;
                break;
              }

              _context6.next = 3;
              return myApp.cordova.qrscan();

            case 3:
              result = _context6.sent;
              _context6.next = 9;
              break;

            case 6:
              _context6.next = 8;
              return $f7.pwaQrcodeScanner();

            case 8:
              result = _context6.sent;

            case 9:
              linkCardSuccess(result);

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function linkCard() {
      return _ref7.apply(this, arguments);
    };
  }();

  var linkCardSuccess = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(result) {
      var r, data;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (result.text) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              if (!result.text.match(myApp.qrscanpattern)) {
                _context7.next = 30;
                break;
              }

              $f7.preloader.show();
              _context7.prev = 4;
              _context7.next = 7;
              return myApp.server.put('user/me/cardnumber', result);

            case 7:
              r = _context7.sent;
              _context7.next = 10;
              return r.json();

            case 10:
              data = _context7.sent;

              if (!(data.error || !r.ok)) {
                _context7.next = 15;
                break;
              }

              $f7.dialog.alert(lng.error_message + ' ' + r.status + ' ' + data.error.message);
              _context7.next = 20;
              break;

            case 15:
              $f7.toast.show({
                text: lng.associate_card_ok_message,
                cssClass: 'bg-color-green text-color-white',
                closeTimeout: 3000
              });
              user.cardnumber = data.cardnumber;
              _context7.next = 19;
              return myApp.user(user);

            case 19:
              $update();

            case 20:
              _context7.next = 25;
              break;

            case 22:
              _context7.prev = 22;
              _context7.t0 = _context7["catch"](4);
              $f7.dialog.alert(lng.error_message + '<br/>' + _context7.t0.message);

            case 25:
              _context7.prev = 25;
              $f7.preloader.hide();
              return _context7.finish(25);

            case 28:
              _context7.next = 31;
              break;

            case 30:
              $f7.dialog.alert(lng.card_cannot_be_associated);

            case 31:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[4, 22, 25, 28]]);
    }));

    return function linkCardSuccess(_x) {
      return _ref8.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div id="app">

    <!-- Right panel -->
    <div class="panel panel-right panel-cover panel-init" 
         data-swipe-only-close="true"
         data-swipe="true">
      <div class="view">
        <div class="page bg-color-primary text-color-white">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <a href="#" class="link panel-close">
                <i class="f7-icons">arrow_left</i>
              </a>
              <div class="title">Menu</div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">
              <div class='block-title'>
                <div class="avatar-medium" id="avatar"></div>
              </div>
              <div class="list">
                <ul class="bg-color-primary mt-0">

                  <li data-if="user.data.childrens.length">
                    <a href="#" @click=${selectUser} class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">person_3_fill</i>
                      </div>
                      <div class="item-inner">
                        <div>
                          <span data-translate="select">${lng.select}</span>
                          <br/>
                          <span data-translate="user">${lng.user}</span> -  PET</div>
                      </div>
                    </a>
                  </li>

                  <li  data-if="!myApp.children">
                    <a href="/me/?pin=yes" class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">person_crop_circle</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="personal_data">${lng.personal_data}</div>
                      </div>
                    </a>
                  </li>
                  <li  data-if="myApp.children">
                    <a href="/me/?pin=yes" class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">paw</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="pet_data">Dati PET</div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/ice/?pin=yes" class="item-link item-content panel-close">
                      <div class="item-media">
                        <img width="28" src="static/icons/ice-white.png"/>
                      </div>
                      <div class="item-inner">
                        <div data-translate="emergency_contacts_ice_html" innerHTML=${lng.emergency_contacts_ice_html}></div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/medical/?pin=yes" class="item-link item-content panel-close">
                      <div class="item-media">
                        <img width="28" src="static/icons/medical-white.png"/>
                      </div>
                      <div class="item-inner">
                        <div data-translate="medical_records_title_html" innerHTML=${lng.medical_records_title_html}></div>
                      </div>
                    </a>
                  </li>


                  <li data-if="!myApp.children">
                    <a href="#" class="item-link item-content panel-close link popup-open" data-popup=".popup-activation-code">
                      <div class="item-media">
                        <i class="icon f7-icons">checkmark_alt</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="activation_code_html" innerHTML=${lng.activation_code_html}></div>
                      </div>
                    </a>
                  </li> 

                  <li data-if="!user.cardnumber && !myApp.children">
                    <a href="#" class="item-link item-content panel-close" @click=${linkCard}>
                      <div class="item-media">
                        <i class="icon f7-icons">qrcode_viewfinder</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="associate_card">${lng.associate_card}</div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#" @click=${addUser} class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">paw</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="add_user_html" innerHTML="${lng.add_user_html}"></div>
                      </div>
                    </a>
                  </li> 

                  <li>
                    <a href="/privacy/" class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">lock_shield</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="privacy_title_html" innerHTML=${lng.privacy_title_html}></div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#" class="item-link item-content panel-close popup-open" data-popup=".popup-contacts">
                      <div class="item-media">
                        <i class="icon f7-icons">at</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="contact" innerHTML=${lng.contact}></div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="/set_language/" class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">globe</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="set_language" innerHTML=${lng.set_language}></div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#" class="item-link item-content panel-close link popup-open" data-popup='.popup-info'>
                      <div class="item-media">
                        <i class="icon f7-icons">info</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="instructions_of_use_html" innerHTML=${lng.instructions_of_use_html}></div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="/marketplace/" class="item-link item-content panel-close">
                      <div class="item-media">
                        <i class="icon f7-icons">gift</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="marketplace_explore" innerHTML=${lng.marketplace_explore}></div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <div class="item-content">
                      ${(!f7.device.cordova) && $h`
                      <img src="static/pwa.png" width="45"/>
                      `}
                    </div>
                  </li>

                  <li>
                    <div class="item-content"></div>
                  </li>

                  <li>
                    <a @click=${logOut} class="item-link item-content panel-close text-color-black text-bold">
                      <div class="item-media">
                        <i class="icon f7-icons">power</i>
                      </div>
                      <div class="item-inner">
                        <div data-translate="exit">${lng.exit}</div>
                      </div>
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Select User -->
    <div class="popup popup-select-user">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title" data-translate="select_user">${lng.select_user}</div>
              <div class="right">
                <a class="link popup-close" data-translate="close">${lng.close}</a>
              </div>
            </div>
          </div>
          <div class="page-content bg-color-white">
            <div class="list no-hairlines">
              <ul id="popup-select-user-ul">
                <!-- <li>
                   <a href="#" @click=${selectUserActive} data-id='primary' class="item-link item-content">
                     <div class="item-media"><img class="avatar-list" src="${user.data.avatar}"/></div>
                     <div class="item-inner">
                       <div class="item-title">${user.name} ${user.lastname}</div>
                       <div class="item-after">${myApp.children ? '' : $h`<i class="f7-icons text-color-secondary">checkmark_alt</i>`}</div>
                     </div>
                   </a>
                 </li> -->
                ${user.data.childrens.map((item) => $h`
                <li>
                  <a href="#" @click=${selectUserActive} data-id='${item.id}' class="item-link item-content">
                    <div class="item-media"><img class="avatar-list" src=""/></div>
                    <div class="item-inner">
                      <div class="item-title">${item.name} ${item.lastname}</div>
                      <div class="item-after">${myApp.children == item.id ? $h`<i class="f7-icons text-color-secondary">checkmark_alt</i>` : ''}</div>
                    </div>
                  </a>
                </li>
                `)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Activation Code -->
    <div class="popup popup-activation-code">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title" data-translate="activation_code">${lng.activation_code}</div>
              <div class="right">
                <a class="link popup-close" data-translate="close">${lng.close}</a>
              </div>
            </div>
          </div>
          <div class="page-content display-flex justify-content-center align-items-center">
            <div class="block text-align-center">
              <img src="static/logo.png" width="250" /> <br />
              <h4 data-translate="activation_code_title"> ${lng.activation_code_title} </h4>
              <p data-translate="activation_code_text"> ${lng.activation_code_text} </p>
              <div class="list text-align-left">
                <ul>
                  <li class="item-content item-input">
                    <div class="item-inner">
                      <div class="item-title item-label" data-translate="activation_code">${lng.activation_code}</div>
                      <div class="item-input-wrap">
                        <input type="text" class="text-upper" id="activationCode" placeholder="ABC 123456 UVXYZ" value="${user.activation_code || ''}" />
                        <span class="input-clear-button"></span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <button class="button button-large button-fill button-round color-secondary" @click=${activationCode}>
                <i class="f7-icons left">square_arrow_down</i>
                <span  data-translate="save">${lng.save}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup contacts -->
    <div class="popup popup-contacts popup-tablet-fullscreen" data-swipe-to-close="true">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg bg-color-secondary"></div>
            <div class="navbar-inner">
              <div class="left">
                <a href="#" class="link popup-close">
                  <i class="f7-icons ios-only">arrow_left</i>
                  <i class="material-icons md-only">arrow_back</i>
                </a>
              </div>
              <div class="title" data-translate="contact">${lng.contact}</div>
            </div>
          </div>
          <div class="page-content unselectable">
            <div class="block">
              <div class="text-align-center margin-bottom">
                <img width="200" src="static/logo.png" />
              </div>

              <p>
                <span data-translate="contacts_text_1"> ${lng.contacts_text_1}: </span> <br/>
                <a class="external text-color-blue" target="_system" href="mailto:assistenza@doctorpass.it"> assistenza@doctorpass.it</a>
              </p>

              <p>
                <span data-translate="contacts_text_2"> ${lng.contacts_text_2}: </span> <br/>
                <a class="external text-color-blue" target="_system" href="mailto:commerciale@doctorpass.it"> commerciale@doctorpass.it</a>
              </p>

              <p>
                <span data-translate="contacts_text_3"> ${lng.contacts_text_3}: </span> <br/>
                <a class="external text-color-blue" target="_system" href="http://www.doctorpass.it"> www.doctorpass.it</a>
              </p>
            </div>
            <div class="my-footer padding-bottom">
              <hr class="sep"/>
              <a href="http://www.processfarm.net" class="link external text-color-black" target="_system">
                <span>Prodotto da <img class="process-services" src="static/process-services.png"/> srl Società Benefit 
                  <br/> 01549880050 - www.processfarm.net</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup info -->
    <div class="popup popup-info popup-tablet-fullscreen unselectable" @popup:open=${getInfo}>
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg bg-color-white"></div>
            <div class="navbar-inner">
              <div class="left margin-left">
                <a href="${DOCUMENTS_ADDRESS}instructions_${lng.key}.pdf" class="external" target="_system">
                  <i class="f7-icons text-color-blue">square_arrow_up</i>
                </a>
              </div>
              <a href="#" class="right link text-color-blue popup-close">
                <span  data-translate="close">${lng.colse}</span>
                <i class="f7-icons right">xmark</i></a>
            </div>
          </div>
          <div class="page-content overflow-auto bg-color-white">
            <div class="content popup-lg-content"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- PWA Qrcode Scanner -->
    <div class="popup popup-tablet-fullscreen popup-qrcode-scan bg-color-black">
      <div style="width:100vw; height: 100vh; position: absolute; top:0; left:0" id="reader"></div>  
      <a href="#" 
         style="position: fixed; bottom:0; left:0; right:0; z-index: 9999999" 
         class="button button-large button-fill color-black margin-top popup-close" 
         @click=${cancelQrcodeScan}>Annulla</a>
    </div>

    <!-- Main content -->
    <div class="view view-main view-init safe-areas" data-url="/"></div>

  </div>
`
    }
    ;
});